import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from "vue";
  import { useStore } from "vuex";
  import { EstateInterface } from "@/types/EstateInterface";
  import { useRoute } from "vue-router";
  import { UserRoles } from "@/enums/UserRoles";
  import router from "@/router";
  import getUserRole from "@/helpers/getUserRole";
  import "tippy.js/dist/tippy.css";
  import "tippy.js/themes/light-border.css";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarShortPanel',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const route = useRoute();
  const { isLandownerRole, isSalesPersonRole } = getUserRole();
  const estates = computed(
    () => store.state.user.landownerEstates as EstateInterface[]
  );
  const account = computed(() => {
    if (
      store.state.user.data.role === UserRoles.LANDOWNER ||
      store.state.user.data.role === UserRoles.SALES_PERSON
    ) {
      return [
        /*{
        action: "",
        icon: "icon-settings.svg",
        iconClass: "gray",
      },
      {
        action: "",
        icon: "icon-question.svg",
        iconClass: "gray",
      },*/
        {
          action: "profile",
          icon: "icon-settings.svg",
          iconClass: route.fullPath.startsWith("/landowner/profile")
            ? "active"
            : "gray",
          tooltipText: "Settings",
        },
        {
          action: "logout",
          icon: "icon-logout.svg",
          tooltipText: "Sign Out",
        },
      ] as unknown[];
    }

    return [
      {
        action: "logout",
        icon: "icon-logout.svg",
      },
    ] as unknown[];
  });
  const activeEstateId = computed(() => store.state.user.selectedEstateId);
  const isAdmin = computed(
    () =>
      route?.meta?.access &&
      (route.meta.access as string[]).includes(UserRoles.SUPER_ADMIN)
  );

  onMounted(() => {
    if (!isAdmin.value) {
      getEstates().then((res) => {
        store.commit(
          "user/setLandownerEstates",
          isSalesPersonRole.value ? res.data.estateIds : res.data
        );

        if (!activeEstateId.value && estates.value.length) {
          onEstate(estates.value[0], false);
        } else if (estates.value.length) {
          const estate = estates.value.find(
            (value) => value._id === activeEstateId.value
          );

          onEstate(estate ? estate : estates.value[0], false);
        }
      });
    }
  });

  const getEstates = () => {
    if (isLandownerRole.value) {
      return store.dispatch("estate/getEstates", {
        landownerId: store.state.user.data._id,
      });
    }

    return store.dispatch("estate/getSalesPersonEstates");
  };

  const onEstate = (estate: EstateInterface, needRedirect = true) => {
    store.commit("user/setSelectedEstate", estate._id);
    store.dispatch("eoi/getEoiCounter", estate._id);
    store.dispatch("contact/getUnwatchedLeads", estate._id);
    store.dispatch("initialHold/getPendingInitialHoldsCounter", estate._id);

    if (needRedirect) {
      router.push({ name: "Dashboard" });
    }
  };

  function checkActiveEstate(estate: EstateInterface) {
    return estate._id === activeEstateId.value;
  }

  function iconClick(type: string) {
    switch (type) {
      case "logout":
        store.dispatch("user/logout").finally(() => {
          router.push("/");
        });
        break;
      case "profile":
        router.push({ name: "LandownerProfile" });
        break;
      default:
        break;
    }
  }

const __returned__ = { store, route, isLandownerRole, isSalesPersonRole, estates, account, activeEstateId, isAdmin, getEstates, onEstate, checkActiveEstate, iconClick, computed, onMounted, get useStore() { return useStore }, get EstateInterface() { return EstateInterface }, get useRoute() { return useRoute }, get UserRoles() { return UserRoles }, get router() { return router }, get getUserRole() { return getUserRole } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})